<span *ngIf="utcOffset"
  >{{ time | date: 'HH':utcOffset }}<span class="blink">:</span>{{ time | date: "mm ('" + utcOffset + "')":utcOffset }}</span
>
<span *ngIf="!utcOffset">{{ time | date: 'HH' }}<span class="blink">:</span>{{ time | date: 'mm' }}</span>
